import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  label: 'Overview',
  to: '/overview'
}, {
  label: 'NCJI',
  to: '/ncji'
}, {
  label: 'Charter',
  to: '/charter'
}, {
  label: 'Constitution',
  to: '/constitution'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-cognarch-white/95 backdrop-blur-sm border-b border-cognarch-border shadow-[0_1px_3px_rgba(0,0,0,0.04)]' : 'bg-transparent border-b border-transparent'}`} data-id="element-105">
      <nav className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16 md:h-20" data-id="element-106">
        {/* Brand */}
        <Link to="/" className="font-serif text-xl md:text-2xl text-cognarch-black hover:text-cognarch-charcoal transition-colors" data-id="element-107">
          Cognarchism
        </Link>

        {/* Desktop Links */}
        <ul className="hidden md:flex items-center gap-8" data-id="element-108">
          {navLinks.map(link => {
          const isActive = location.pathname === link.to;
          return <li key={link.label} data-id="element-109">
                <Link to={link.to} className={`text-sm tracking-wide transition-colors relative py-1 ${isActive ? 'text-cognarch-black font-medium' : 'text-cognarch-gray hover:text-cognarch-black'}`} data-id="element-110">
                  {link.label}
                  {isActive && <motion.div layoutId="nav-underline" className="absolute -bottom-0.5 left-0 right-0 h-px bg-cognarch-black" transition={{
                duration: 0.3,
                ease: [0.21, 0.47, 0.32, 0.98]
              }} data-id="element-111" />}
                </Link>
              </li>;
        })}
        </ul>

        {/* Mobile Toggle */}
        <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden p-2 -mr-2 text-cognarch-charcoal hover:text-cognarch-black transition-colors" aria-label={mobileOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileOpen} data-id="element-112">
          {mobileOpen ? <XIcon className="w-5 h-5" strokeWidth={1.5} data-id="element-113" /> : <MenuIcon className="w-5 h-5" strokeWidth={1.5} data-id="element-114" />}
        </button>
      </nav>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-115">
        {mobileOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.25,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="md:hidden bg-cognarch-white border-b border-cognarch-border overflow-hidden" data-id="element-116">
            <ul className="px-6 py-6 space-y-1" data-id="element-117">
              {navLinks.map(link => {
            const isActive = location.pathname === link.to;
            return <li key={link.label} data-id="element-118">
                    <Link to={link.to} className={`block py-3 text-sm tracking-wide border-b border-cognarch-border/50 transition-colors ${isActive ? 'text-cognarch-black font-medium' : 'text-cognarch-gray hover:text-cognarch-black'}`} data-id="element-119">
                      {link.label}
                    </Link>
                  </li>;
          })}
            </ul>
          </motion.div>}
      </AnimatePresence>
    </header>;
}